/**
 * The in-app path a click inside the chat should open, or null. A router Link
 * already navigated and prevented the default, so routing it again would push
 * the same page twice and Back would look like it did nothing.
 */
export function internalLinkHref(event: {
	target: EventTarget | null
	defaultPrevented: boolean
}): string | null {
	if (event.defaultPrevented) return null
	if (!(event.target instanceof Element)) return null
	const href = event.target.closest("a")?.getAttribute("href")
	return href?.startsWith("/") ? href : null
}
